module.exports = __webpack_public_path__ + "images/emoji/triangular_ruler.a40914c0dc13a74b078c.png";